// Vendors
import $ from 'jquery';
import _ from 'lodash';
import { AJAX_URL } from '../config';

// Config
const CONTAINER = '.search-autosuggest';
const INPUT = '.search-autosuggest__input';
const RESULTS = '.search-autosuggest__results';
const LOADING = '.search-autosuggest__loading';

/**
 * Initialise a single autosuggest instance. All selectors are scoped to the
 * given container, so any number of search boxes can live on the same page
 * (e.g. the header search and the /search page) without interfering.
 *
 * @param {HTMLElement} container The `.search-autosuggest` element.
 */
function initSearchAutosuggest(container) {
  const $container = $(container);
  const $input = $container.find(INPUT);
  const $results = $container.find(RESULTS);
  const $loading = $container.find(LOADING);
  const showExcerpt = $container.data('search-autosuggest-show-excerpt');

  // Hidden until the user types
  $results.hide();

  function hideResults() {
    $results.empty().hide();
    $container.removeClass('search-autosuggest--showing-results');
  }

  function renderResults(res) {
    let output = '';

    if (res.data.hits.length) {
      output = '<ul>';

      res.data.hits.forEach((post) => {
        output += '<li>';
        output += `<a href="${post.permalink}">`;
        output += `<h5>${post.post_highlighted_title}</h5>`;

        if (showExcerpt) {
          output += `<p>${post.post_excerpt}</p>`;
        }

        output += '</a></li>';
      });

      if (res.data.view_more) {
        output += `<li><a href="#" class="search-autosuggest__view-all btn btn-default">View All</a></li>`;
      }

      output += '</ul>';
    } else {
      output =
        '<div class="search-autosuggest__no-results">No posts found...</div>';
    }

    $loading.removeClass('search-autosuggest__loading--visible');
    $results.empty().append(output).show();
    $container.addClass('search-autosuggest--showing-results');
  }

  function runQuery() {
    const search = $input.val();

    if (!search.length) {
      hideResults();
      return;
    }

    $results.show();
    $loading.addClass('search-autosuggest__loading--visible');

    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}wlPostAjaxSearchAutoSuggest`,
      data: { search, limit: 5 },
      dataType: 'json',
      encode: true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      success: renderResults,
      error: () => {
        $loading.removeClass('search-autosuggest__loading--visible');
        $results
          .empty()
          .append(
            '<div class="search-autosuggest__no-results">There was an error fetching the posts.</div>'
          )
          .show();
        $container.addClass('search-autosuggest--showing-results');
      }
    });
  }

  // Fetch suggestions as the user types (debounced)
  $input.on('input', _.debounce(runQuery, 150));

  // Submit the full search on Enter
  $input.on('keydown', (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      $container.closest('form').submit();
    }
  });

  // Clicks inside the container keep it focused; "View All" submits the form
  $container.on('click', (event) => {
    event.stopPropagation();
    $container.addClass('search-autosuggest--focused');

    if ($(event.target).hasClass('search-autosuggest__view-all')) {
      event.preventDefault();
      $container.closest('form').submit();
    } else if ($input.val().length) {
      $results.show();
    }
  });
}

// Initialise every instance on the page
$(CONTAINER).each((index, container) => initSearchAutosuggest(container));

// Clicking anywhere else closes all open suggestion panels
$('html').on('click', () => {
  $(CONTAINER).removeClass('search-autosuggest--focused');
  $(RESULTS).hide();
});
